module.exports = __webpack_public_path__ + "img/welcome-light.120b1287.svg";